Object.defineProperty(exports, "__esModule", {
    value: true
});
var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en';

var CRYPTOCOMPARE_CURRENCIES = exports.CRYPTOCOMPARE_CURRENCIES = ['BTC', 'USD', 'EUR'];

var ETHER_DEFAULT_SYMBOL = exports.ETHER_DEFAULT_SYMBOL = 'Ξ';

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    etherSymbol: ETHER_DEFAULT_SYMBOL,
    locale: DEFAULT_LOCALE
};
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethtools/build/constants.js
// module id = CdkY
// module chunks = 0